
import React from 'react';
import { Poll } from '@/types/poll';

interface CurrentLinkNoticeProps {
  poll: Poll;
}

const CurrentLinkNotice: React.FC<CurrentLinkNoticeProps> = ({ poll }) => {
  if (!poll.linked_card_id) return null;
  
  return (
    <div className="bg-amber-50 dark:bg-amber-950/30 p-3 rounded-md text-sm mb-4 text-amber-700 dark:text-amber-300">
      This poll is currently linked to card #{poll.linked_card_id}. 
      Selecting a different card will update the link.
    </div>
  );
};

export default CurrentLinkNotice;
